import React from 'react';
import { CheckIcon, DownloadIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
const included = ['Plan completo de 7 días', 'Worksheets imprimibles', 'Checklists semanales y mensuales', 'Ejercicios y preguntas de reflexión', 'Bonos especiales incluidos', 'Acceso inmediato desde tu teléfono o computadora'];
export function Pricing() {
  return <section id="comprar" className="w-full scroll-mt-6 bg-cream px-5 py-20 sm:px-8 sm:py-28" data-id="element-107" data-mp="1vu1r8jpetdsw">
      <div className="mx-auto max-w-4xl" data-id="element-108" data-mp="1rsyew76klzwf">
        <header className="text-center" data-id="element-109" data-mp="1ru166g7t24cv">
          <p className="text-[0.7rem] uppercase tracking-[0.22em] text-clay" data-id="element-110" data-mp="25ry3xfxzwgt4">
            Tu inversión
          </p>
          <h2 className="mt-4 font-serif text-4xl leading-tight text-ink sm:text-5xl" data-id="element-111" data-mp="20slf4pnkcznw">
            Menos de lo que cuesta una comida fuera de casa
          </h2>
        </header>

        <div className="mt-12 grid gap-px overflow-hidden border border-sand bg-sand md:grid-cols-[1.1fr_0.9fr]" data-id="element-112" data-mp="3c8a2hi4qc0p8">
          <div className="bg-linen p-8 sm:p-10" data-id="element-113" data-mp="3vzyncicgrb3m">
            <h3 className="font-serif text-2xl text-ink" data-id="element-114" data-mp="3vz72o2kemxs4">Qué recibes hoy</h3>
            <ul className="mt-6 space-y-3" data-id="element-115" data-mp="4ruideo8647z">
              {included.map(item => <li key={item} className="flex items-start gap-3 text-base text-cocoa" data-id="element-116" data-mp="9ta4zb61wish">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-terracotta" aria-hidden="true" data-id="element-117" data-mp="erletlwcitap" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col justify-center bg-cream p-8 text-center sm:p-10" data-id="element-118" data-mp="3i7irq2lw6fcq">
            <p className="text-sm text-cocoa/70" data-id="element-119" data-mp="3n7eu5xexxyq6">
              Precio regular <span className="line-through" data-id="element-120" data-mp="3n52570armo3m">$19 USD</span>
            </p>
            <p className="text-sm text-cocoa/70" data-id="element-121" data-mp="3ryn2eq4jbe1r">
              Precio especial <span className="line-through" data-id="element-122" data-mp="2uizjfn2ue2kn">$17 USD</span>
            </p>
            <p className="mt-5 font-serif text-7xl leading-none text-terracotta" data-id="element-123" data-mp="2zhkkfopx4qa5">
              $9
              <span className="ml-2 font-sans text-base uppercase tracking-[0.18em] text-clay" data-id="element-124" data-mp="2rgv1fihc64fu">
                USD
              </span>
            </p>
            <p className="mt-3 text-xs uppercase tracking-[0.18em] text-clay" data-id="element-125" data-mp="2mh0axg1h3gvb">
              Oferta por tiempo limitado
            </p>
            <div className="mt-8" data-id="element-126" data-mp="318inf3v4it9x">
              <BuyButton fullWidth data-id="element-127" data-mp="2w7be30dc1m15" />
            </div>
            <p className="mt-4 flex items-center justify-center gap-2 text-xs text-cocoa/70" data-id="element-128" data-mp="2w9o4m1x5p4pt">
              <DownloadIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-129" data-mp="28k38sifwmcz4" />
              Descarga inmediata en PDF
            </p>
          </div>
        </div>
      </div>
    </section>;
}